<div class="card p-0 bg-white mb-4 no-border m-b-colgap">
  <div class="media m-b-colgap">
    <a
      [routerLink]="[
        '/catalogue',
        'tools',
        useCase.tool ? useCase.tool.slug : 'unknown-tool',
        'tool-use-cases',
        useCase.slug
      ]"
    >
      <figure class="media-left">
        <p class="image">
          <img
            *ngIf="useCase.image"
            [src]="storagePath + useCase.image + '-videoCard.jpg'"
            [alt]="useCase.name"
          />
          <img
            *ngIf="!useCase.image"
            src="./assets/images/blog-default.png"
            [alt]="useCase.name"
          />
        </p>
      </figure>
    </a>
    <div class="media-content">
      <h4 class="title has-text-dark is-4 m-b-sm">
        <a
          [routerLink]="[
            '/catalogue',
            'tools',
            useCase.tool ? useCase.tool.slug : 'unknown-tool',
            'tool-use-cases',
            useCase.slug
          ]"
        >
          {{ useCase.name | stripHtml }}
        </a>
      </h4>
      <p *ngIf="useCase.shortSentence">
        {{ useCase.shortSentence }}
      </p>

      <ng-container *ngIf="useCase.tool">
        <div class="content is-small">
          <strong class="is-bold">Related tool: </strong>
          <a [routerLink]="['/catalogue', 'tools', useCase.tool.slug]"
            ><strong>{{ useCase.tool.name }}</strong></a
          >
        </div>
      </ng-container>
    </div>
  </div>

  <hr class="has-background-white-bis is-large mt-0" />
</div>
